// extracted by mini-css-extract-plugin
export default {"content":"SpecialProjects_content__6nG1U","card":"SpecialProjects_card__IexSg","cover":"SpecialProjects_cover__1DQI0","cardContent":"SpecialProjects_cardContent__lmXXN"};